module.exports = __webpack_public_path__ + "static/media/counter-green.6ab146db.png";